import styled from 'styled-components';

import { Skeleton } from '@ovpn-ui/core';

export const Wrapper = styled.span`
    display: flex;
    gap: 4px;
    align-items: center;
`;

export const Loader = styled(Skeleton)`
    display: inline-flex;
    align-self: center;
` as typeof Skeleton;
